import { CommonTabGroup } from "components/tab/TabGroup";
import { useDispatch, useSelector } from "react-redux";
import { setIntialPage } from "redux/slices/focusItemsSlice";
import { setActiveTab } from "redux/slices/focusItemsSlice";
import { FOCUS_ITEMS_TABS, INACTIVE } from "../enums";

const FocusItemTab = () => {
  const dispatch = useDispatch()
  const {
    tab: activeTab
  } = useSelector((state) => state.focusItem)
  const _activeTab = FOCUS_ITEMS_TABS.find((t) => t.value === activeTab)

  const onTabSwitch = (tab) => {
    const url = new URL(window.location);
    url.searchParams.set('state', tab.value)
    url.searchParams.set('page', 1)
    window.history.replaceState({}, '', url)
    dispatch(setIntialPage(1))
    dispatch(setActiveTab(tab))
  }

  const Tab = ({ tab }) => {
    return (
      <div
        className={`${_activeTab === tab
          ? 'text-rand-100 border-secondary-500'
          : 'text-rand-200 border-transparent hover:border-rand-300 cursor-pointer'
          } focus:outline-none px-6 py-3 text-sm font-medium border-b-2`}
        onClick={() => onTabSwitch(tab)}
      >
        {tab.label}
      </div>
    )
  }
  return <CommonTabGroup>
    {FOCUS_ITEMS_TABS.map((n, index) => (
      <Tab key={`${n}-${index}`} tab={n} />
    ))}
  </CommonTabGroup>
}

export default FocusItemTab
